import { render, staticRenderFns } from "./sms-send-log.vue?vue&type=template&id=50795d2b&scoped=true&"
import script from "./sms-send-log.vue?vue&type=script&lang=js&"
export * from "./sms-send-log.vue?vue&type=script&lang=js&"
import style0 from "./sms-send-log.vue?vue&type=style&index=0&id=50795d2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50795d2b",
  null
  
)

export default component.exports